import { createContextualCan } from '@casl/react';
import { AbilityContext } from '../context/ability-provider';

export default createContextualCan(AbilityContext.Consumer);
